module.exports = __webpack_public_path__ + "assets/img/cloud7.b52aded9.png";